module.exports = __webpack_public_path__ + "img/kws_red.4151850c.svg";